<template>
  <div
    class="posts-toolbar bg-white"
  >
    <slot>
      <q-btn-group rounded>
        <DateRangePickerBtn
          label="Filter by Date"
          :model-value="dateRange"
          rounded
          @update:modelValue="selectDateRange"
        />
        <q-btn
          v-if="dateRange"
          icon="fa fa-times"
          @click="clearDateRange()"
        />
      </q-btn-group>
    </slot>
    <MediaFilter
      :model-value="filters.mediaTypes"
      rounded
      @update:modelValue="$emit('update:filters', {...filters, mediaTypes: $event})"
    />
    <PostsPlatformToolbar
      :category-ids="filters.categoryIds"
      :lifecycle-statuses="filters.lifecycleStatuses"
      @change="onCategoriesChange"
      @lifecycle-change="onLifecycleChange"
    />
    <slot name="append" />
  </div>
</template>

<style lang="scss">
@import '../../../styles/quasar.variables';

.posts-toolbar {
  padding: 0 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  > * {
    width: auto;
    margin: 1rem 0;
  }

  @media screen and (min-width: $breakpoint-lg-min) {
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    > * {
      margin-bottom: .75rem;
    }
  }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { DateRange, PostFilters } from '@/type';
import DateRangePickerBtn from '@/components/form/DateRangePickerBtn.vue';
import MediaFilter from '@/components/form/MediaFilter.vue';
import PostsPlatformToolbar from './PostsPlatformToolbar.vue';


export default defineComponent({
  emits: ['update:filters'],
  components: {
    DateRangePickerBtn,
    MediaFilter,
    PostsPlatformToolbar,
  },
  props: {
    filters: {
      type: Object as () => PostFilters,
      required: true,
    },
  },
  computed: {
    dateRange(): DateRange|undefined {
      if (this.filters.since && this.filters.until) {
        return {
          start: this.filters.since,
          end: this.filters.until,
        };
      }
      return undefined;
    },
  },
  methods: {
    onCategoriesChange({ categoryIds, socialSiteIds }: {
      categoryIds: Record<number, number[]>,
      socialSiteIds: number[],
    }) {
      this.$emit('update:filters', { ...this.filters, categoryIds, socialSiteIds });
    },
    selectDateRange(dateRange: DateRange) {
      this.$emit('update:filters', {
        ...this.filters,
        since: dateRange.start,
        until: dateRange.end,
      });
    },
    clearDateRange() {
      this.$emit('update:filters', {
        ...this.filters,
        since: null,
        until: null,
      });
    },
    onLifecycleChange(values: string[] | null) {
      this.$emit('update:filters', {
        ...this.filters,
        lifecycleStatuses: values && values.length > 0 ? values : undefined,
      });
    },
  },
});
</script>
